import React from "react";
import ReactDOM from "react-dom";
import MenuToggle from "./MenuToggle";

/**
 * ObjectFitImages for Polyfill images
 */
import objectFitImages from "object-fit-images";

/**
 * Magnnific Popup for modals
 */
import "magnific-popup";
import { parseCarouselClassLists, setCarouselProps } from "./carouselSetup";

/**
 * Related Products Table functionality
 */
import { relatedProductsTable } from "./relatedProductsTable";

/**
 * Related Products Table functionality
 */
import { navigation } from "./navigation";

/**
 * Lazysizes for images
 */
import "lazysizes";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

import "./select2.full.min.js";

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.rias = window.lazySizesConfig.rias || {};

// configure available widths to replace with the {width} placeholder
window.lazySizesConfig.rias.widths = [320, 480, 640, 720, 960, 1024, 2048];
window.lazySizesConfig.rias.absUrl = true;

const DEBUG = process.env.NODE_ENV === "development";

console.log("Environment: ", process.env.NODE_ENV);

if (DEBUG) {
  console.log("Loaded main.js");
}

jQuery(function ($) {
  $(document).ready(function () {
    objectFitImages();
    relatedProductsTable($);
    navigation($);

    $(".js-open-popup").magnificPopup({
      type: "inline",
      midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
    });

    //probably temporary
    // change angle for in page menu
    $("#in-page-menu-toggle").click(function () {
      $("#angle-in-page").toggleClass("fa-angle-up");
    });
  });

  //find all the carousels on the page
  if (document.querySelectorAll("[ class*=js-carousel ]").length > 0) {
    let carouselArray = parseCarouselClassLists(
      document.querySelectorAll("[ class*=js-carousel ]")
    );
    setCarouselProps(carouselArray);
  }

  // Advanced search menu ui
  ReactDOM.render(
    <MenuToggle
      ref={(ref) => {
        window.advancedSearch = ref;
      }}
    />,
    document.querySelector("#advanced-search")
  );

  $(".menu-products a").on("click", function (e) {
    e.preventDefault();
    if (window.advancedSearch) {
      window.advancedSearch.toggle();
    }
  });

  $("#doc-form-wrapper select#all-products").select2({
    placeholder: "Choose a Product",
    multiple: true,
    allowClear: true,
    width: "100%",
  });
  $("#doc-form-wrapper select#document-type").select2({
    placeholder: "Choose a Document Type",
    multiple: true,
    allowClear: true,
    width: "100%",
  });

  $("ul.list.paginate-list").each(function () {
    var currentPage = 0;
    var numPerPage = 10;
    var $table = $(this);
    $table.bind("repaginate", function () {
      $table
        .find(".doc-item")
        .hide()
        .slice(currentPage * numPerPage, (currentPage + 1) * numPerPage)
        .show();
    });
    $table.trigger("repaginate");
    var numRows = $table.find(".doc-item").length;
    var numPages = Math.ceil(numRows / numPerPage);
    var $pager = $('<ul class="pagination pagination-md"></ul>');
    for (var page = 0; page < numPages; page++) {
      var pagenum = page + 1;
      $('<li class="page-item"></li>')
        .html(
          '<a href="#" class="inactive ajax-pagination">' + pagenum + "</a>"
        )
        .bind(
          "click",
          {
            newPage: page,
          },
          function (event) {
            currentPage = event.data["newPage"];
            $table.trigger("repaginate");
            $(this).addClass("active").siblings().removeClass("active");
          }
        )
        .appendTo($pager)
        .addClass("clickable");
    }
    $pager.insertAfter($table).find("li.page-item:first").addClass("active");
  });
  $(".smart-module-docs").on("click", "a.ajax-pagination", function (e) {
    $("html, body").animate(
      {
        scrollTop: $(".smart-module-docs").offset().top,
      },
      500
    );
    return false;
  });
});
